<template lang="pug">
  v-container(fluid).storefront
    //- Categories text
    .categories-container.px-4
      v-card.categorie-card(v-for='(item, index) in categories' flat :to='"/store/"+item.link')
        p {{item.name}}
    //- Images
    v-carousel.size-carousel(hide-delimiter-background)
      v-carousel-item.text-center(v-for="(img, i) in carrousel" :key="i")
        img.size-carousel.mx-auto(:src="img.src")
    //- Categoires images
    .text-center.my-3
      .categories-tender__title Elige una categoria
    .mx-auto.my-0(style="width: 90%;")
      vue-slick-carousel.my-0(v-bind='options')
        template(#prevArrow='arrowOption')
          .slick-left-control
            v-icon(color="black" size="60") mdi-chevron-left
        template(#nextArrow='arrowOption')
          .slick-right-control
            v-icon(color="black" size="60") mdi-chevron-right
        v-card(flat v-for="categorie of categories" :to='"/store/"+categorie.link')
          v-img(:src="categorie.icon")
    //- Stores
    v-container.categories-tender
      .py-5.px-1.text-center
        span.categories-tender__title La solución definitiva para tu negocio en línea
        span.categories-tender__description  Adquiere tu solución multi-tienda y administra todos tus negocios desde un solo lugar
      v-btn.mr-0.gradient-color.categories-tender__btn(@click="$router.push('/search')")
        | ver tiendas
        v-img.ml-1(src="@/assets/icons/icon-store.png" width="20")
    v-row.mx-auto.dashed-card-container
      v-col.circular-center-column(cols="12" sm="4" md="4" v-for="card of cards" style="justify-content:start !important")
        v-card.rounded-lg.pa-2(height="220" width="200" :color="card.color" :to="card.to")
          .dashed-border.d-flex.align-center
            v-img(:src="card.src" height="70%" contain)
        h1.text-center {{card.title}}
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import Explore from '@/components/custom/Explore'
  // screens
  import homebg from '@/assets/images/homebg2.png'
  import bg from '@/assets/images/prueba-tender.png'
  import Purchases from '../custom/transactions/Purchases'
  import plans from '@/views/custom/plans/Plans'

  export default {
    name: 'Home',
    components: {
      Purchases,
      Explore,
      plans,
      VueSlickCarousel,
    },

    data: () => ({
      // mainBg: require('@/assets/images/background-tender.png'),
      options: {
        arrows: true,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 4,
        infinite: true,
        rows: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      },
      cards: [
        {
          title: 'Hazte Empresa',
          src: require('@/assets/icons/home/gastos.png'),
          color: '#008e95',
          to: '/dashboard/',
        },
        {
          title: 'Encuentra tiendas',
          src: require('@/assets/icons/home/ordenes.png'),
          color: '#00cae3',
          to: '/search/',
        },
        {
          title: 'Blog',
          src: require('@/assets/icons/categories/art.png'),
          color: '#008e95',
          to: '/blog/',
        },
      ],
      carrousel: [
        {
          src: require('@/assets/images/slides/slide-1.png'),
        },
        {
          src: require('@/assets/images/slides/slide-2.png'),
        },
        {
          src: require('@/assets/images/slides/slide-3.png'),
        },
        {
          src: require('@/assets/images/slides/slide-4.png'),
        },
      ],
      cycle: true,
      colors: [
        'indigo',
        'warning',
        'pink darken-2',
        'red lighten-1',
        'deep-purple accent-4',
      ],
      bg: bg,
      homebg: homebg,
      current_feature: 0,
      features_empresas: [
        {
          name: 'Gestiona inventario',
          description: 'Asigna cantidades y precios a tus productos, descuenta inventario por venta, controla tus margenes de  utilidad.',
        },
        {
          name: 'Gestiona tus movimientos',
          description: 'Accede a tu historial de ventas y comprobantes, compras, traslados, ordenes, gastos y devoluciones,',
        },
        {
          name: 'Observa tu crecimiento',
          description: 'Genera reportes de tus indicadores de crecimiento, tus ordenes a la tienda virtual, tus productos mas Vendidos, y tu utilidad Neta',
        },
        {
          name: 'Gestiona tu Equipo de Ventas',
          description: 'Crea Colaboradores y Vendedores para que hagan ventas en Punto Virtual o en Punto Físico.',
        },

      ],
      features_pos: [
        {
          name: 'Vende en tu Punto de venta (POS)',
          description: 'Genera Facturas de Venta, Gestiona en Tiempo Real tus Unidades Disponibles, Recibe Pedidos, Atiende a tus Clientes con Nuestro POS',
        },
        {
          name: 'Comparte tu Tienda virtual',
          description: 'Comparte tu enlace personalizado entre tus clientes para que te hagan pedidos por tu tienda Virtual',
        },
        {
          name: 'Fideliza a tus clientes',
          description: 'Enviales promociones, y cupones de descuento',
        },
        {
          name: 'Gestiona Pedidos',
          description: 'Indica los estados de los pedidos que recibas, procesalos, para que tus clientes sepan el estado de sus pedidos, mantente conectado con ellos',
        },
        {
          name: 'Personaliza tus ventas',
          description: 'Usa el Sistema de Venta Personalizada, lleva tus ventas a otro Nivel con el Carrito de Compras Asistido, Muestrale a tus clientes , tus productos en tiempo Real',
        },
      ],
      categories: [
        {
          name: 'Arte',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/arte.png'),
          className: 'category__vivir',
          link: 'Arte',
        },
        {
          name: 'Belleza',
          body: 'Encuentra los hechos noticiosos más destacados a nivel mundial. ',
          icon: require('@/assets/categories/belleza.png'),
          className: 'category__vivir',
          link: 'Belleza',

        },
        {
          name: 'Deporte',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/deportes.png'),
          className: 'category__vivir',
          link: 'Deportes',
        },
        {
          name: 'Electrodomésticos',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/electrodomesticos.png'),
          className: 'category__vivir',
          link: 'Electrodomésticos',
        },
        {
          name: 'Hogar',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/hogar.png'),
          className: 'category__vivir',
          link: 'Hogar',
        },

        {
          name: 'Minimarket',
          body: 'Encuentra los hechos noticiosos más destacados de Colombia.',
          icon: require('@/assets/categories/minimarket.png'),
          className: 'category__vivir',
          link: 'Minimarket',
        },

        {
          name: 'Farmacia',
          body: 'Encuentra toda la información deportiva de Colombia y el mundo. ',
          icon: require('@/assets/categories/farmacia.png'),
          className: 'category__vivir',
          link: 'Farmacias',
        },
        {
          name: 'Ferreterias',
          body: 'Encuentra las tendencias y los hechos más vírales de las redes sociales.',
          icon: require('@/assets/categories/ferreteria.png'),
          className: 'category__vivir',
          link: 'Ferretería',
        },
        {
          name: 'Tecnología',
          body: 'Encuentra toda la información de salud, ciencia, educación y medio ambiente. ',
          icon: require('@/assets/categories/tecnologia.png'),
          className: 'category__vivir',
          link: 'Tecnología',
        },
        {
          name: 'Moda',
          body: 'Encuentra todo lo relacionado con las últimas novedades tecnológicas. ',
          icon: require('@/assets/categories/moda.png'),
          className: 'category__vivir',
          link: 'Moda',
        },
        {
          name: 'Restaurantes',
          body: 'Encuentra las mejores noticias de los negocios y la economía dd Colombia y el mundo. ',
          icon: require('@/assets/categories/restaurantes.png'),
          className: 'category__vivir',
          link: 'Restaurantes',
        },
        {
          name: 'Licoreras',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/licores.png'),
          className: 'category__vivir',
          link: 'Licorera',
        },
        {
          name: 'Naturista',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/naturista.png'),
          className: 'category__vivir',
          link: 'Naturista',
        },

        {
          name: 'Jugueteria',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/jugueteria.png'),
          className: 'category__vivir',
          link: 'Jugueteria',
        },
        {
          name: 'Videojuegos',
          body: 'Encuentra música, cine, artistas y espectáculo.',
          icon: require('@/assets/categories/videojuegos.png'),
          className: 'category__vivir',
          link: 'Videojuegos',
        },
      ],

    }),
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      isLogIn () {
        return !!this.$store.state.users.user
      },
    },
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
    },
    mounted () {
      const vm = this
      /* if (!vm.isLogIn) {
        window.location.href = 'http://home.tenderapp.co/'
      } else {
        vm.$router.replace('/dashboard').catch(err => {
          // console.log(err)
        })
      } */

      vm.categories.sort(function (a, b) {
        if (a.name > b.name) {
          return 1
        }
        if (a.name < b.name) {
          return -1
        }
        // a must be equal to b
        return 0
      })
      vm.onResize()
    },
    methods: {
      sendToPlans () {
        const vm = this
        if (vm.isLogIn) {
          vm.$router.replace('/dashboard/plans').catch(err => {
            console.log(err)
          })
        } else {
          vm.$router.replace('/pages/register').catch(err => {
            console.log(err)
          })
        }
      },
      slideFeature (num) {
        this.cycle = false
        // console.log(num)
        this.current_feature = num
      },
      querySelections (v) {
        this.loading = true
        // Simulated ajax query
        setTimeout(() => {
          this.items = this.states.filter(e => {
            return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
          this.loading = false
        }, 500)
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
    },

  }
</script>
<style scoped lang="scss">
  .storefront{
    padding: 0;
    min-height: 100%;
    overflow: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
    &__sheet{
      max-height: calc(100vh - 50px)
    }
    .categories-container{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center !important;
      height: 60px;
      &::-webkit-scrollbar {
        display: none;
      }
      @media(max-width: 790px){
        overflow-x: scroll !important;
        flex-wrap: nowrap;
        justify-content: start;
      }
      .categorie-card{
        margin: 2px 10px !important;
        p {
          font-size: 15px;
        }
      }
      .categorie-card:hover {
        color: #008e95 !important;
      }
    }
    .dashed-card-container{
      @media(min-width: 1100px){
        width: 70% !important;
      }
    }
    .dashed-border{
      height: 100%;
      width: 100%;
      border: 5px white dashed;
    }
    .size-carousel{
      height: 200px !important;
      width: 100% !important;
      @media(min-width: 740px){
        height: 250px !important;
      }
      @media(min-width: 820px){
        height: 350px !important;
      }
      @media(min-width: 1100px){
        height: 450px !important;
      }
      @media(min-width: 1400px){
        img{
          width: 80% !important;
        }
      }
    }
  }
  .screen-carousel{
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
     &__container{
       z-index: -2;
     }
    &__screener{
      position: relative;
      text-align: center;
      width: 310px;
      height: 650px;
      margin: auto;
      right: 0;
      left: 0;
      @media(min-width: 1024px){
        position: relative;
      }
    }
  }
  .landing__header{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .homebg {
    /*max-height: 600px;*/
    top: 0;
    position: absolute;
    height: 88vh;
    @media(min-width: 1024px){
      position: unset;
      height: unset;
    }
    width: 100%;
    object-fit: fill;
    background: linear-gradient(
          to right bottom,
          rgba(#3c8f9f, 0.8),
          rgba(#2e1b6d, 0.8));
  }

  li {
    list-style: none;
    position: relative;
  }
  ul li:before {
    position: absolute;
    content: '¬';
    left: -20px;
    top: -20px;
    margin-top: 0;
    transform: rotate(120deg);
    color: #00CAE3;
    font-size: 50px;
  }
  .category{
    background-color: #5271bd;
    background-image: linear-gradient(315deg, #5271bd 0%, #31b3bb 74%);
    border-radius: 20px;
    padding: 10px;
    color: white
  }
  .category-card{
    color: #fff;
    position:relative;
    overflow: hidden;
    border-radius: 5px;
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p{
      margin:0;

    }
    &__content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      h3{
        line-height: 20px;
      }
      p{
        max-width: 90px !important;
        font-size: 7px !important;
      }
    }
    &__circle{
      z-index: -1;
      border-radius: 50%;
      width: 70px;
      height: 70px;
      position: absolute;
      right:-15px;
      bottom: -15px;
      display: flex;
      color: #fff;
      justify-content:center;
      align-items: center;
    }
    &.category{
      &__nacion{
        background-image: linear-gradient(to right, #009552, #00a955, #00a955, #00c362);
        .category-card__circle{
          background: #009850;
        }
      }
      &__deportes{
        background-image: linear-gradient(to right, #0046a6, #0046a6, #2b6dc7, #2b6dc7);
        .category-card__circle{
          background: #0046a6;
        }
      }
      &__viral{
        background-image: linear-gradient(to right, #de5c0c, #de5c0c, #e57e39, #e57e39);
        .category-card__circle{
          background: #dd5503;
        }
      }
      &__internacional{
        background-image: linear-gradient(to right, #6008ac, #6008ac, #802cc7, #802cc7);
        .category-card__circle{
          background: #56039b;
        }
      }
      &__vivir{
        background-image: linear-gradient(to right, #09a7ad, #09a7ad, #2cc2c7, #2cc2c7);
        .category-card__circle{
          background: #16999e;
        }
      }
      &__tecnologia{
        background-image: linear-gradient(to right, #aaaf0c, #aaaf0c, #c2c72c, #c2c72c);
        .category-card__circle{
          background: #878b06;
        }
      }
      &__eyn{
        background-image: linear-gradient(to right, #63a701, #63a701, #81c225, #81c225);
        .category-card__circle{
          background: #71af19;
        }
      }
      &__entretenimiento{
        background-image: linear-gradient(to right, #ad0988, #ad0988, #c2259f, #c2259f);
        .category-card__circle{
          background: #890c6d;
        }
      }
    }
  }
  .banner-title{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    h1 {
      color: #000;
      font-size: 3rem;

    }
    p{
      color :#000;
      font-size: 1.5rem;

    }
  }
  .test--tender {
    &__container {
      max-width: 100%;
      margin: auto auto 0;
      height: 65vh;
      background-image: linear-gradient(
          to right bottom,
          rgba(#3c8f9f, 0.8),
          rgba(#2e1b6d, 0.8)),
      url(../../assets/images/prueba-tender.png);
      background-size: cover;
      background-position: top;
      position: relative;

      &__text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .info-tender {
    max-width: 100%;
    margin: auto auto 0;
    background-image: url(../../assets/images/background-tender-black-and-white.png);
    background-size: cover;
    background-position: top;
    position: relative;
    padding-top: 8.9rem;
    &__administra {
      color: #fff;
      font-weight: 600;
      font-size: 2.5rem;
      text-transform:uppercase;
      background: #35a4bc;
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    &__vende {
      color: #fff;
      font-weight: 600;
      font-size: 2.5rem;
      text-transform:uppercase;
      background: rgb(49,172,187);
      background: linear-gradient(90deg, rgba(49,172,187,1) 0%, rgba(77,92,172,1) 100%);
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    &__description {
      font-size: 1.3rem;
      font-weight: 600;
      margin-left: 2rem;
      margin-right: 2rem;
    }

    &__item {
      font-size: 1.1rem;
      font-weight: 400;
      padding-left: 1.3rem;
    }
  }

  .main-tender {
    padding-top: 60px;
    max-width: 100%;
    margin: auto auto 0;
    background-image: linear-gradient(
        to right bottom,
        rgba(#3c8f9f, 0.8),
        rgba(#2e1b6d, 0.8)),
    url(../../assets/images/homebg2.png);
    background-size: cover;
    background-position: top;
    position: relative;
  }

  .categories-tender {
    max-width: 100%;
    margin: auto auto 0;
    background-image: url(../../assets/images/background-tender-black-and-white.png);
    background-size: cover;
    background-position: top;
    position: relative;

    &__title {
      font-size: 2rem;
      color: #33a4b8;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.2rem;
      display: block;
      text-align: center;
    }

    &__description {
      font-size: 1.8rem;
      color: #a2a2a2;
      font-weight: 400;
      margin-top: 1.5rem;
      width: 55%;
      text-align: center;
    }

    &__img {
      width: 100%;
      margin: 2px;
      transition: all .2s;
      &:hover {
        transform: scale(1.04) translateY(-.45rem);
      }
    }

    &__shops {
      margin-top: 2rem;
      font-size: 1.75rem;
      color: #33a4b8;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.2rem;
      display: block;
      text-align: center;
    }

    &__btn {
      margin-top: 1.5rem;
      left: 50%;
      transform: translateX(-50%);
      transition: all .2s;
      &:hover {
        transform: scale(1.04) translateY(-.35rem) translateX(-50%);
      }
    }
  }
</style>
